// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__25wd0","col":"Table_col__f3Jb7","fulfillmentStatus":"Table_fulfillmentStatus__3YNmr","emailCol":"Table_emailCol__2O05Q"};